export function replaceVariables(
  template: string,
  data: Record<string, string | number>,
): string {
  const regex = /{(.*?)}/g;
  return (
    template?.replace(regex, (_match: string, variable: string): string => {
      const value = data[variable.trim()];
      return value !== undefined ? String(value) : "";
    }) || ""
  );
}
